<button
	type="button"
	class="flex w-full cursor-pointer flex-col rounded-2xl bg-gray-000 py-2 px-4 text-start transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
	data-cy="daily-history-card"
	[id]="headerId"
	[attr.aria-controls]="listId"
	[attr.aria-expanded]="expanded()"
	(click)="toggle()">
	<div class="flex items-center justify-between gap-2 mb-2 font-medium" data-cy="daily-history-card-summary">
		<span class="tabular-nums text-3.25 font-bold text-gray-900" data-cy="daily-history-card-date">{{
			history().timeOfEventShamsi
		}}</span>
		<span class="flex items-center gap-1 text-gray-900">
			<span class="text-xs text-gray-600">حجم:</span>
			<ui-number
				format="1.0-0"
				class="tabular-nums text-sm font-medium text-gray-900"
				[value]="history().tradedQuantity" />
		</span>
	</div>

	@let primary = primaryRow();
	<div class="flex items-center justify-between gap-2 mb-2" data-cy="daily-history-card-close">
		<span class="shrink-0 text-xs text-gray-600">{{ primary.label }}:</span>
		<span class="flex min-w-0 items-center gap-1">
			@let change = changePercent();
			@if (change !== null) {
				<!-- `ltr` so a negative change reads «(-1.5%)», its minus on the left of the figure. -->
				<span
					dir="ltr"
					class="tabular-nums text-sm font-medium"
					data-cy="daily-history-card-change"
					[class.text-green-500]="change > 0"
					[class.text-red-500]="change < 0"
					[class.text-gray-500]="change === 0">
					(<ui-number [value]="change" [maxDigit]="2" />%)
				</span>
			}
			<ui-number format="1.0-0" class="tabular-nums text-sm font-medium text-gray-900" [value]="primary.value" />
			<span class="text-3.25 text-gray-600"> ریال </span>
		</span>
	</div>

	<div data-cy="daily-history-card-list" [id]="listId" [class]="listClasses()">
		<div class="overflow-hidden">
			<div class="flex flex-col gap-2">
				@for (row of extraRows(); track row.label) {
					<div
						class="flex items-center justify-between gap-2"
						[attr.data-cy]="'daily-history-card-' + row.label">
						<span class="shrink-0 text-xs text-gray-600">{{ row.label }}:</span>
						<div class="flex items-center gap-0.5">
							<ui-number
								format="1.0-0"
								class="tabular-nums text-sm text-gray-900 font-medium"
								[value]="row.value" />
							<span class="text-3.25 text-gray-600"> ریال </span>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<div class="flex items-center justify-center pt-0.5">
		<ui-chevron size="sm" color="text-gray-900" [position]="expanded() ? 'up' : 'down'" />
	</div>
</button>
